import React, { Component } from 'react';
import { translate } from 'react-i18next';
import $ from 'jquery';
import StartDatePicker from './StartDatePicker/StartDatePicker';
import EndDatePicker from './EndDatePicker/EndDatePicker';
import lastOperationsIcon from '../../img/last-operations-icon.png';
import Dropdown from '../../../../copms/Dropdown/Dropdown';
import { request } from '../../../../config';
import { getFormatedDate } from '../../../../helpers/fotmatDate';
import AddDocument from '../../../../copms/Modal/AddDocument';

function base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
function saveFile(name, type, data) {
    if (data !== null && navigator.msSaveBlob)
        return navigator.msSaveBlob(new Blob([data], { type: type }), name);
    var a = $("<a style='display: none;'/>");
    var url = window.URL.createObjectURL(new Blob([data], { type: type }));
    a.attr("href", url);
    a.attr("download", name);
    $("body").append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
}

class List extends Component {
    state = {
        status: 1,
        toDate: null,
        fromDate: null,
        invoices: [],
        id: null,
        checkedItems: [],
        selectAllChecked: false,
        verificationOpen: false,
        verificationCode: null,
        statuses: [],
        statusId: null,
        invoiceNumber: '',
        bencName: '',
        open: false,
        item: null,
        payType: null,
        payableAmount: '',
        calculatedAmount: '',
        accountId: null,
        totalAmountWithComission: null,
        commission: null,
        isBlocked: 0,
        invoice: null,
        documentId: null
    }

    updateDate = (name, value) => {
        this.setState({ [name]: value });
    };

    componentDidMount() {
        this.getStatuses();
        this.getInvoiceList();
    }

    getStatuses = () => {
        // this.props.updateAppState('isLoadingTransparentBackground', true);
        let getStatusesRequestBody = { token: localStorage.getItem('token') }
        fetch(request("swift/getFileTypeList", getStatusesRequestBody))
            .then(res => res.text())
            .then((getStatusesResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getStatusesResponse = JSON.parse(getStatusesResponseJSON);
                if (getStatusesResponse.status.statusCode !== 1) {
                    if (getStatusesResponse.status.statusCode === 200) {
                        this.props.logout();
                    }
                }
                // this.props.updateAppState('isLoadingTransparentBackground', false);
                this.setState({ fileTypes: getStatusesResponse.items ? getStatusesResponse.items : [] });
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getInvoiceList = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getInvoiceListRequestBody = {
            token: localStorage.getItem('token'),
            beginDate: getFormatedDate(this.state.fromDate, '-'),
            endDate: getFormatedDate(this.state.toDate, '-')
        }
        fetch(request("swift/getSwiftOperationInList", getInvoiceListRequestBody))
            .then(res => res.text())
            .then((getInvoiceListResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getInvoiceListResponse = JSON.parse(getInvoiceListResponseJSON);
                if (getInvoiceListResponse.status.statusCode !== 1) {
                    if (getInvoiceListResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getInvoiceListResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
                this.setState({ invoices: getInvoiceListResponse.items ? getInvoiceListResponse.items : [] });
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getFile = (documentId) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getFileRequestBody = {
            token: localStorage.getItem('token'),
            documentId
        }
        fetch(request("swift/getSwiftInFile", getFileRequestBody))
            .then(res => res.text())
            .then((getFileResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getFileResponse = JSON.parse(getFileResponseJSON);
                if (getFileResponse.status.statusCode !== 1) {
                    if (getFileResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getFileResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    let arrrayBuffer = base64ToArrayBuffer(getFileResponse.document.document);
                    saveFile(getFileResponse.document.documentName, `application/${getFileResponse.document.documentExt}`, arrrayBuffer);
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getFiles = (documentId) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getFileRequestBody = {
            token: localStorage.getItem('token'),
            documentId
        }
        fetch(request("swift/getSwiftInFiles", getFileRequestBody))
            .then(res => res.text())
            .then((getFileResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getFileResponse = JSON.parse(getFileResponseJSON);
                if (getFileResponse.status.statusCode !== 1) {
                    if (getFileResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getFileResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    let files = [];
                    getFileResponse.files.forEach(file => {
                        const fileBytes = base64ToArrayBuffer(file.document);
                        const fileBlob = new Blob([fileBytes], {
                            type: file.documentExt ? `application/${file.documentExt}` : 'application/octet-stream'
                        });

                        files.push({
                            files: fileBlob,
                            fileName: file.documentName,
                            type: file.documentTypeId
                        });
                    });
                    this.setState({ files: files, open: true, documentId: documentId });
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    addFiles = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let deleteInvoiceRequestBody = {
            token: localStorage.getItem('token'),
            documentId: this.state.documentId,
        }
        let data = new FormData();
        data.append('reqObject', JSON.stringify(deleteInvoiceRequestBody));
        this.state.files.forEach(file => {
            data.append('files', file.files, file.fileName);
        });
        data.append('docTypes', this.state.files.map(item => item?.type));
        fetch(request("swift/addOrDeleteSwiftInFiles", data, "POST_FORM"))
            .then(res => res.text())
            .then((deleteInvoiceResponseJSON) => {
                const JSON = require('true-json-bigint');
                let deleteInvoiceResponse = JSON.parse(deleteInvoiceResponseJSON);
                if (deleteInvoiceResponse.status.statusCode !== 1) {
                    if (deleteInvoiceResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(deleteInvoiceResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                } else {
                    this.setState({ open: false, files: [] });
                    this.getInvoiceList();
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    chooseFile = (event) => {
        let files = this.state.files;
        for (let i = 0; i < event.target.files.length; i++) {
            files.push({ files: event.target.files[i], fileName: event.target.files[i].name });
        }
        this.setState({ files: files });
    }
    chooseFileType = (index, type) => {
        let files = [...this.state.files];
        files[index].type = type;
        this.setState({ files: files });
    }
    deleteFile = (index) => {
        let files = this.state.files;
        files.splice(index, 1);
        this.setState({ files: files });
    }
    downloadFile = (index) => {
        let arrrayBuffer = this.state.files[index].files;
        this.saveFile(this.state.files[index].fileName, null, arrrayBuffer);
    }

    dropdownItemHandler = (index, item) => {
        switch (index) {
            case 0:
                this.getFile(item.documentId);
                break;
            case 1:
                this.getFiles(item.documentId);
                break;
            default: break;
        }
    }

    render() {
        let { invoices, fromDate, toDate, fileTypes, open, files } = this.state;
        let { t } = this.props;
        return (
            <>
                <AddDocument open={open} fileTypes={fileTypes} files={files} chooseFileType={this.chooseFileType} chooseFile={this.chooseFile} deleteFile={this.deleteFile} downloadFile={this.downloadFile} triggerFunc={() => this.addFiles()} onClose={() => this.setState({ open: false })} />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Incoming funds')}</h2>
                    </div>
                    {/* <Link to='/dashboard/finance/invoices/create' class="dashboard-header-route-button">{t('Create invoice')}</Link> */}
                </div>
                <div className="dashboard-salary-container flex-wrap">
                    <div className="dashboard-payment-container-data-section w-100">
                        <div className="dashboard-salary-order-container">
                            <div className="dashboard-salary-order-container-box flex-nowrap mt-3">
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("Started date")}</label>
                                    <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                        <StartDatePicker value={fromDate} toDate={toDate} name="fromDate" updateDate={this.updateDate} />
                                    </div>
                                </div>
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("expiration date")}</label>
                                    <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                        <EndDatePicker value={toDate} fromDate={fromDate} name="toDate" updateDate={this.updateDate} />
                                    </div>
                                </div>
                            </div>
                            <div className="dashboard-salary-order-container-box justify-content-end">
                                <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main" onClick={this.getInvoiceList}>{t("Search")}</button>
                                <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-outline" onClick={() => this.setState({ fromDate: null, toDate: null })}>{t("Clear")}</button>
                            </div>
                            {invoices.length === 0 ?
                                <div className="dashboard-last-operations-section-content" style={{ justifyContent: 'center' }}>
                                    <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" />
                                    <p className="dashboard-last-operations-section-content-status">{t('you do not currently have any active transactions')}</p>
                                </div>
                                : <><div style={{ height: "50vh", overflowY: "auto", overflowX: 'auto', width: "100%" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead style={{ position: 'sticky', top: 0, left: 0, zIndex: '100' }}>
                                            <tr className='border-0'>
                                                <th>{t("Document number")}</th>
                                                <th>{t("Amount")}</th>
                                                <th>{t("currency")}</th>
                                                <th>{t("reference number")}</th>
                                                <th>{t("Sender country")}</th>
                                                <th>{t("Status")}</th>
                                                <th>{t("Compliance status")}</th>
                                                <th>{t("Compliance refusal reason")}</th>
                                                <th>{t("Bank date")}</th>
                                                <th>{t("Attached documents")}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoices.map(item => (
                                                <tr>
                                                    <td>{item.documentId || '--'}</td>
                                                    <td>{item.amount || '--'}</td>
                                                    <td>{item.currency || '--'}</td>
                                                    <td>{item.referenceNumber || '--'}</td>
                                                    <td>{item.senderCountryName || '--'}</td>
                                                    <td>{item.statusName || '--'}</td>
                                                    <td>{item.complianceStatusName || '--'}</td>
                                                    <td>{item.complianceRefusalReason || '--'}</td>
                                                    <td>{getFormatedDate(item.bankDate, 'dd.mm.yyyy') || '--'}</td>
                                                    <td>{item.isAddedFiles ? <><svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none" style={{ cursor: 'pointer' }} onClick={() => this.getFiles(item.documentId)}>
                                                        <path d="M19.5625 13.2506C25.7199 13.2506 28.5625 18.9345 28.5625 18.9345C28.5625 18.9345 25.7199 24.6183 19.5625 24.6183C13.4051 24.6183 10.5625 18.9345 10.5625 18.9345C10.5625 18.9345 13.4051 13.2506 19.5625 13.2506Z" stroke="black" stroke-linejoin="round" />
                                                        <path d="M22.2487 18.9345C22.257 19.3032 22.1914 19.6699 22.056 20.0131C21.9206 20.3562 21.718 20.6688 21.4601 20.9325C21.2022 21.1962 20.8942 21.4058 20.5542 21.5488C20.2142 21.6919 19.849 21.7656 19.4802 21.7656C19.1113 21.7656 18.7461 21.6919 18.4061 21.5488C18.0661 21.4058 17.7582 21.1962 17.5003 20.9325C17.2424 20.6688 17.0397 20.3562 16.9043 20.0131C16.7689 19.6699 16.7034 19.3032 16.7116 18.9345C16.7116 18.2 17.0034 17.4956 17.5227 16.9763C18.0421 16.457 18.7464 16.1652 19.4809 16.1652C20.2153 16.1652 20.9197 16.457 21.439 16.9763C21.9583 17.4956 22.2501 18.2 22.2501 18.9345H22.2487Z" stroke="black" stroke-linejoin="round" />
                                                    </svg></> : this.props.t('no item')}</td>
                                                    <td>
                                                        <div className="dashboard-finance-section-cards-section-button-group">
                                                            <Dropdown className="center"
                                                                dropdownItems={
                                                                    [
                                                                        {
                                                                            title: <><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className='mr-1'>
                                                                                <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#364153" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M4.66663 6.66667L7.99996 10L11.3333 6.66667" stroke="#364153" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M8 10V2" stroke="#364153" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>{this.props.t('Upload document')}</>
                                                                        },
                                                                        {
                                                                            title: <><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className='mr-1'>
                                                                                <path d="M8.82263 13.5013L14 8.20001" stroke="#364153" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M10.6666 3.99999L5.05731 9.72399C4.80734 9.97403 4.66692 10.3131 4.66692 10.6667C4.66692 11.0202 4.80734 11.3593 5.05731 11.6093C5.30734 11.8593 5.64642 11.9997 5.99997 11.9997C6.35352 11.9997 6.6926 11.8593 6.94264 11.6093L12.552 5.88532C13.0519 5.38525 13.3327 4.70709 13.3327 3.99999C13.3327 3.29289 13.0519 2.61473 12.552 2.11466C12.0519 1.61473 11.3737 1.33389 10.6666 1.33389C9.95953 1.33389 9.28138 1.61473 8.78131 2.11466L3.17131 7.83799C2.4211 8.5882 1.99963 9.6057 1.99963 10.6667C1.99963 11.7276 2.4211 12.7451 3.17131 13.4953C3.92151 14.2455 4.93902 14.667 5.99997 14.667C7.06093 14.667 8.07843 14.2455 8.82864 13.4953" stroke="#364153" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>{this.props.t('Add document')}</>
                                                                        }
                                                                    ]
                                                                }
                                                                dropdownItemHandler={(i) => this.dropdownItemHandler(i, item)} />
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                    {/* <div className="dashboard-salary-order-container-box justify-content-end">
                                        <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main" disabled={!checkedItems.length} onClick={() => this.getFile()}>{t("Download PDF")}</button>
                                        <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main" disabled={!checkedItems.length} onClick={() => this.getFile(true)}>{t("Download Excel")}</button>
                                    </div> */}
                                </>
                            }
                        </div>
                    </div>
                    {/* <div className="dashboard-payment-container-confirmation-section">
                        <div className="dashboard-payment-container-confirmation-section-header">
                            <h3 className="dashboard-payment-container-confirmation-section-header-title">{t('Invoice services')}</h3>
                        </div>
                        <div className="dashboard-payment-container-confirmation-section-content">
                            <img src={transferConfirmation} alt="img" className="dashboard-payment-container-confirmation-section-content-image" />
                            <div className="dashboard-payment-container-confirmation-section-content-description">
                                <p>{t('invoice text')}</p>
                            </div>
                        </div>
                    </div> */}
                </div>
            </>
        )
    }
}

export default translate("translation")(List);